import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/costPrestore/list',
    method: 'post',
    data: data
  });
}
export function fetchMainList(data) {
  return request({
    url: '/pmsservice/api/costPrestore/mainList',
    method: 'post',
    data: data
  });
}
export function insert(data) {
  return request({
    url: '/pmsservice/api/costPrestore/insert',
    method: 'post',
    data: data
  });
}
export function getCustomerList(data) {
  return request({
    url: '/pmsservice/api/customerOa/list',
    method: 'post',
    data: data
  });
}
export function getCustomerHouseList(data) {
  return request({
    url: '/pmsservice/api/house/list',
    method: 'post',
    data: data
  });
}
export function getGroupList(data) {
  return request({
    url: '/pmsservice/api/weCharLinkHouse/deopDownGroupList',
    method: 'post',
    data: data
  });
}
export function getBuildingList(data) {
  return request({
    url: '/pmsservice/api/weCharLinkHouse/deopDownBuildList',
    method: 'post',
    data: data
  });
}
export function getHouseList(data) {
  return request({
    url: '/pmsservice/api/weCharLinkHouse/deopDownHouseList',
    method: 'post',
    data: data
  });
} // 收费项目

export function getChargeItem(data) {
  return request({
    url: '/pmsservice/api/chargeItem/list',
    method: 'post',
    data: data
  });
} // 收费标准

export function getChargeStandard(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/list',
    method: 'post',
    data: data
  });
}
export function betchOffset(data) {
  return request({
    url: '/pmsservice/api/costPrestore/betchOffset',
    method: 'post',
    data: data
  });
}
export function OffsetOweList(data) {
  return request({
    url: '/pmsservice/api/costPrestore/OffsetOweList',
    method: 'post',
    data: data
  });
}
export function OffsetOwe(data) {
  return request({
    url: '/pmsservice/api/costPrestore/OffsetOwe',
    method: 'post',
    data: data
  });
} // 收支列表

export function inOutList(data) {
  return request({
    url: '/pmsservice/api/costPrestore/inOutList',
    method: 'post',
    data: data
  });
} // 退款

export function refund(data) {
  return request({
    url: '/pmsservice/api/costPrestore/refund',
    method: 'post',
    data: data
  });
} // 查看明细

export function inOutDetialList(data) {
  return request({
    url: '/pmsservice/api/costPrestore/inOutDetialList',
    method: 'post',
    data: data
  });
}